export const ACRONYMS = ['ar'];

export const removeWhitespaceAndNewline = (value: string): string => {
  if (!value) return value;
  return value?.replace(/(\r\n|\n|\r)/gm, '')?.replace(/\s/g, '');
};

export const capitalise = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const capitaliseWords = (value: string): string => {
  const words = value.split(' ');
  const capitalisedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1),
  );
  return capitalisedWords.join(' ');
};

export const removeTrailingWhitespace = (value: string) => value?.trim();

export const pluralise = (
  count: number,
  singular: string,
  plural: string,
): string => (count === 1 ? singular : plural);

export const capitliseAcronyms = (str: string): string =>
  ACRONYMS.includes(str.toLowerCase()) ? str.toUpperCase() : str;
